// Sticky sale timer: fixed pill (bottom-left) + sale modal. Markup comes from sections/bd-header-timer.liquid.
(function () {
  const SCROLL_THRESHOLD = 6; // px of movement before the direction counts
  const TOP_OFFSET = 50; // always expanded near the top of the page
  const CLOSE_DELAY = 300; // matches the modal transition in bd-sticky-timer.css
  const instances = new Map();

  class BdStickyTimer {
    constructor(root, modal) {
      this.root = root;
      this.modal = modal;
      this.sectionId = root.dataset.sectionId;
      this.pill = root.querySelector('[data-bd-sticky-timer-pill]');
      this.dueTime = new Date(root.dataset.dueDate).getTime();
      this.lastY = window.scrollY;
      this.ticking = false;
      this.closeTimer = null;
      this.lastFocus = null;

      this.onScroll = this.onScroll.bind(this);
      this.onKeydown = this.onKeydown.bind(this);

      this.moveToBody();
      this.bind();
      this.update();

      this.expiryTimer = setInterval(() => this.checkExpired(), 5000);
      this.checkExpired();
    }

    // The section lives inside the header group, move the fixed elements out so no ancestor can break `position: fixed`
    moveToBody() {
      [this.root, this.modal].forEach((el) => document.body.appendChild(el));
    }

    bind() {
      this.pill.addEventListener('click', () => this.openModal());
      this.modal.querySelectorAll('[data-bd-sale-modal-close]').forEach((el) => {
        el.addEventListener('click', () => this.closeModal());
      });
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      document.addEventListener('keydown', this.onKeydown);
    }

    onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this.update();
        this.ticking = false;
      });
    }

    update() {
      const y = Math.max(window.scrollY, 0);
      const delta = y - this.lastY;

      if (y < TOP_OFFSET) {
        this.setCollapsed(false);
      } else if (delta > SCROLL_THRESHOLD) {
        this.setCollapsed(true); // scrolling down
      } else if (delta < -SCROLL_THRESHOLD) {
        this.setCollapsed(false); // scrolling up
      }
      if (Math.abs(delta) > SCROLL_THRESHOLD || y < TOP_OFFSET) this.lastY = y;

      this.updateTheme();
    }

    setCollapsed(collapsed) {
      this.root.dataset.collapsed = String(collapsed);
    }

    // Dark surface while the pill overlaps the footer
    updateTheme() {
      const footer = document.querySelector('footer');
      let overFooter = false;
      if (footer) {
        const pillRect = this.root.getBoundingClientRect();
        const footerRect = footer.getBoundingClientRect();
        overFooter = pillRect.bottom > footerRect.top && pillRect.top < footerRect.bottom;
      }
      this.root.dataset.theme = overFooter ? 'dark' : 'light';
    }

    openModal() {
      clearTimeout(this.closeTimer);
      this.lastFocus = document.activeElement;
      this.modal.hidden = false;
      document.body.classList.add('bd-sale-modal-open');
      this.pill.setAttribute('aria-expanded', 'true');
      // next frame so the transition runs
      requestAnimationFrame(() => {
        this.modal.classList.add('is-open');
        const closeBtn = this.modal.querySelector('.bd-sale-modal__close');
        if (closeBtn) closeBtn.focus();
      });
    }

    closeModal() {
      if (this.modal.hidden) return;
      this.modal.classList.remove('is-open');
      document.body.classList.remove('bd-sale-modal-open');
      this.pill.setAttribute('aria-expanded', 'false');
      this.closeTimer = setTimeout(() => {
        this.modal.hidden = true;
      }, CLOSE_DELAY);
      if (this.lastFocus && typeof this.lastFocus.focus === 'function') this.lastFocus.focus();
    }

    onKeydown(event) {
      if (this.modal.hidden) return;
      if (event.key === 'Escape') {
        this.closeModal();
        return;
      }
      if (event.key !== 'Tab') return;

      // keep focus inside the sheet
      const focusable = this.modal.querySelectorAll('a[href], button:not([disabled])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    checkExpired() {
      if (this.dueTime && Date.now() >= this.dueTime) this.destroy();
    }

    destroy() {
      clearInterval(this.expiryTimer);
      clearTimeout(this.closeTimer);
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('bd-sale-modal-open');
      this.root.remove();
      this.modal.remove();
      instances.delete(this.sectionId);
    }
  }

  function removeMoved(sectionId) {
    const existing = instances.get(sectionId);
    if (existing) existing.destroy();
    // leftovers in <body> from a previous render of the section
    document.querySelectorAll(`body > [data-section-id="${sectionId}"]`).forEach((el) => {
      if (el.matches('[data-bd-sticky-timer], [data-bd-sale-modal]')) el.remove();
    });
  }

  function init() {
    document.querySelectorAll('[data-bd-sticky-timer]').forEach((root) => {
      if (root.parentElement === document.body) return; // already moved
      const sectionId = root.dataset.sectionId;
      const modal = root.parentElement.querySelector('[data-bd-sale-modal]');
      if (!modal) return;
      removeMoved(sectionId);
      instances.set(sectionId, new BdStickyTimer(root, modal));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', (event) => {
    removeMoved(event.detail.sectionId);
  });
})();
